import type { FC } from 'react'
import React from 'react'
import { FinancingRequestStepper } from '@/components/composed/financing/FinancingRequestStepper/FinancingRequestStepper'
import { FinancingConsultingCommunicationMethodSelector } from './components/FinancingConsultingCommunicationMethodSelector'
import { FinancingConsultingError } from './components/FinancingConsultingError'
import { FinancingConsultingSuccess } from './components/FinancingConsultingSuccess'
import { FinancingConsultingFormStep } from './components'

const FinancingConsulting: FC = () => {
  return (
    <FinancingRequestStepper
      FormComponent={FinancingConsultingFormStep}
      LoginComponent={FinancingConsultingFormStep}
      RegistrationComponent={FinancingConsultingFormStep}
      AfterFormSubmitComponent={FinancingConsultingCommunicationMethodSelector}
      ErrorComponent={FinancingConsultingError}
      SuccessComponent={FinancingConsultingSuccess}
    />
  )
}

export default FinancingConsulting
